// extracted by mini-css-extract-plugin
export default {"courseBottomContainer":"CourseBottom_courseBottomContainer__OeGEo"};